<template>
  <span class="voucher-table-head-button">
    <span v-if="useDay || hasDiscountRate" class="month">
      <span>{{ useDay }}</span>
      <span v-if="hasDiscountRate" class="discount">{{ discountRate }}%</span>
    </span>

    <span class="price">
      <span>&#65510;{{ amount }}</span>
      <span v-if="hasDiscountDisplayAmount" class="discount-display-amount">
        &#65510;{{ discountDisplayAmount }}</span
      >
      <span v-if="hasMonthAmount" class="summary">
        &lpar;월 &#65510;{{ monthAmount }}&rpar;
      </span>
    </span>
  </span>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import { setNumberCommas } from '@/common/utils/common'
  const props = defineProps({
    productInfo: {
      type: Object,
      default: () => ({}),
    },
  })

  const useDay = computed(() => props.productInfo?.use_day ?? '')
  const discountRate = computed(() => props.productInfo?.discount_rate ?? '')
  const amount = computed(
    () => setNumberCommas(props.productInfo?.amount) ?? '',
  )
  const discountDisplayAmount = computed(
    () => setNumberCommas(props.productInfo?.discountdisplayamount) ?? '',
  )
  const monthAmount = computed(
    () => setNumberCommas(props.productInfo?.month_amount) ?? '',
  )

  const hasDiscountRate = computed(() => discountRate.value !== '')
  const hasMonthAmount = computed(() => monthAmount.value !== '')
  const hasDiscountDisplayAmount = computed(
    () => discountDisplayAmount.value !== '',
  )
</script>
<style lang="scss" scoped>
  .voucher-table-head-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    align-items: center;
    .month {
      flex: 1;
      display: flex;
      justify-content: start;
      align-items: center;
    }
    .discount-display-amount {
      display: block;
      font-size: 12px;
      text-decoration: line-through;
      line-height: 16px;
      font-weight: 400;
    }
  }
</style>
